import React from 'react';

export class Heading2 extends React.Component {
    render() {
		return (
            <h2 className={this.props.classes}>{this.props.children}</h2>
        )
	}
}